export default "__VITE_ASSET__5o0qoWRb__"